const RESERVED_PARAMS = ["page", "limit", "sort", "direction"];

export const getFilterCount = (searchParams: URLSearchParams) => {
  const copy = new URLSearchParams({ ...Object.fromEntries(searchParams) });

  for (const param of RESERVED_PARAMS) {
    copy.delete(param);
  }

  return copy.size;
};
